import { AppLoader } from '@/components/AppLoader';
import { useCurrentUserContext } from '@/contexts';
import { Redirect } from './Redirect';

export const MagicTabsIndex = () => {
  const { isLoading, isAuthenticated } = useCurrentUserContext();

  // Without this gate `isAuthenticated` is still false while the profile query
  // is in flight, and Redirect fires from a mount-only effect, so a logged-in
  // user landing on `/` would always be sent to /magic.
  if (isLoading) {
    return <AppLoader />;
  }

  return <Redirect path={isAuthenticated ? '/dashboard' : '/magic'} />;
};
